import React, {useContext, useEffect} from 'react';
import {Grid} from '@material-ui/core';
import {Warning} from '@material-ui/icons';
import {PSingleLine} from 'components/TypographyShortcuts';
import Show from 'components/utils/Show';
import {useGetBillingAddress, useGetProfile} from 'hooks/useGetEndpoint';
import {UserContext} from 'context/UserContext';

const BillingInfoBox = () => {
    const {data} = useGetBillingAddress();
    const {hasBillingInfo, billingInfo, actions} = useContext(UserContext);

    useEffect(() => {
        if (data) {
            actions.updateBillingInfo(data);
        }
        //eslint-disable-next-line
    }, [data]);

    return (
        <Grid item xs container alignItems='center'>
            <Show condition={hasBillingInfo}>
                <div>
                    <PSingleLine key={1}>
                        {billingInfo?.billing_address_street}
                    </PSingleLine>
                    <PSingleLine key={2}>
                        {billingInfo?.billing_address_city}
                        {', '}
                        {billingInfo?.billing_address_zip}{' '}
                        {billingInfo?.billing_address_state}
                    </PSingleLine>
                </div>
            </Show>
            <Show condition={!hasBillingInfo}>
                <PSingleLine>
                    <Warning
                        style={{
                            verticalAlign: 'middle',
                            color: 'orange',
                        }}
                    />{' '}
                    No Billing Address on File
                </PSingleLine>
            </Show>
        </Grid>
    );
};

const DeliveryInfoBox = () => {
    const {data} = useGetProfile();
    const {hasDeliveryInfo, profile, actions} = useContext(UserContext);

    useEffect(() => {
        if (data) {
            actions.updateProfile(data);
        }
        //eslint-disable-next-line
    }, [data]);

    return (
        <Grid item xs container alignItems='center'>
            <Show condition={hasDeliveryInfo}>
                <div>
                    <PSingleLine key={1}>
                        {profile?.applicant_delivery_address_street}
                    </PSingleLine>
                    <PSingleLine key={2}>
                        {profile?.applicant_delivery_address_city}
                        {', '}
                        {profile?.applicant_delivery_address_zip}{' '}
                        {profile?.applicant_delivery_address_state}
                    </PSingleLine>
                </div>
            </Show>
            <Show condition={!hasDeliveryInfo}>
                <PSingleLine>
                    <Warning
                        style={{
                            verticalAlign: 'middle',
                            color: 'orange',
                        }}
                    />{' '}
                    No Delivery Address on File
                </PSingleLine>
            </Show>
        </Grid>
    );
};

export default BillingInfoBox;
export {DeliveryInfoBox};
